import React from 'react';
import { StyleSheet, View, Image, Text } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import IMAGES from 'shared/constants/images';
import { ACTION, ITEM, SCREEN } from 'shared/modules/auth/constants/mixpanel';
import Button from 'shared/modules/common/components/atoms/Button';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import Mixpanel from 'shared/vendor/Mixpanel';
import useSignOutUser from 'web/modules/auth/hooks/use-sign-out-user';

type Props = {
  open?: boolean;
  onCancel?: () => void;
};

const Signout = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const signOutUser = useSignOutUser();

  return (
    <Dialog
      open={props.open}
      title=""
      showCloseButton={false}
      id="signout-dialog"
      onCloseButtonPress={props.onCancel}
      onBackdropPress={props.onCancel}
      style={style.root}
    >
      <View style={style.mainContainer}>
        <View style={style.topContainer}>
          <Image
            source={IMAGES.signOutIllustration}
            style={style.headerImage}
          />

          <Text style={style.title}>ログアウトしますか？</Text>
        </View>

        <View
          style={[style.buttonGroup, isBigScreen && style.buttonGroupBigScreen]}
        >
          <View style={style.firstButtonView}>
            <Button
              title="ログアウト"
              onPress={() => {
                Mixpanel.trackEvent(`${SCREEN.LOGOUT} - ${ACTION.CLICK}`, {
                  Item: ITEM.YES,
                });

                signOutUser();
              }}
              style={[
                style.firstButton,
                isBigScreen && style.firstButtonBigScreen,
              ]}
              id="signout-dialog-signout-button"
            />
          </View>
          <View style={style.secondButtonView}>
            <Button
              title="キャンセル"
              onPress={() => {
                Mixpanel.trackEvent(`${SCREEN.LOGOUT} - ${ACTION.CLICK}`, {
                  Item: ITEM.NO,
                });

                props.onCancel?.();
              }}
              variant="outlined"
              style={[
                style.secondButton,
                isBigScreen && style.secondButtonBigScreen,
              ]}
              id="signout-dialog-cancel-button"
            />
          </View>
        </View>
      </View>
    </Dialog>
  );
};

const style = StyleSheet.create({
  root: {
    maxHeight: 624,
  },
  headerImage: {
    width: 184,
    height: 184,
    alignSelf: 'center',
  },
  buttonGroup: {
    justifyContent: 'flex-end',
  },
  buttonGroupBigScreen: {
    flexDirection: 'row',
    flex: 1,
    alignItems: 'flex-end',
  },
  title: {
    fontSize: 20,
    fontWeight: '600',
    lineHeight: 24,
    alignSelf: 'center',
    marginBottom: 24,
  },
  firstButtonView: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  secondButtonView: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  firstButton: {
    alignSelf: 'center',
    marginBottom: 16,
  },
  secondButton: {
    alignSelf: 'center',
  },
  firstButtonBigScreen: {
    alignSelf: 'center',
    marginBottom: 0,
    marginRight: 8,
  },
  secondButtonBigScreen: {
    alignSelf: 'center',
    marginLeft: 8,
  },
  mainContainer: {
    flex: 1,
  },
  topContainer: {
    flex: 1,
  },
});

export default Signout;
